module.exports = __webpack_public_path__ + "static/media/close_btn.74407bc9.png";